export default "__VITE_PUBLIC_ASSET__7d42fcd6__"